/* Prop & Piston Performance theme JS. No dependencies. */
(function () {
  'use strict';
  var PP = window.PP || {};
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  /* ---------- Storage (guarded) ---------- */
  var store = {
    get: function (k) { try { return JSON.parse(localStorage.getItem(k)); } catch (e) { return null; } },
    set: function (k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) {} },
    del: function (k) { try { localStorage.removeItem(k); } catch (e) {} }
  };

  /* ---------- Vehicles ---------- */
  var vehicles = String(PP.vehicles || '').split(/\r?\n/).map(function (l) {
    var p = l.split('|').map(function (s) { return s.trim(); });
    if (p.length < 4 || !p[0] || !p[1]) return null;
    return { make: p[0], model: p[1], ys: parseInt(p[2], 10), ye: parseInt(p[3], 10), url: p[4] || '' };
  }).filter(Boolean);

  function years() {
    var min = 9999, max = 0;
    vehicles.forEach(function (v) { if (v.ys < min) min = v.ys; if (v.ye > max) max = v.ye; });
    var out = [];
    for (var y = max; y >= min; y--) out.push(y);
    return out;
  }
  function makesFor(y) {
    var s = {};
    vehicles.forEach(function (v) { if (!y || (y >= v.ys && y <= v.ye)) s[v.make] = 1; });
    return Object.keys(s).sort();
  }
  function modelsFor(y, make) {
    return vehicles.filter(function (v) { return v.make === make && (!y || (y >= v.ys && y <= v.ye)); });
  }
  function fill(sel, items, placeholder, valueKey, labelKey) {
    sel.innerHTML = '';
    var o = document.createElement('option');
    o.value = ''; o.textContent = placeholder; sel.appendChild(o);
    items.forEach(function (it) {
      var op = document.createElement('option');
      op.value = valueKey ? it[valueKey] : it;
      op.textContent = labelKey ? it[labelKey] : it;
      sel.appendChild(op);
    });
    sel.disabled = items.length === 0;
  }

  /* ---------- Garage ---------- */
  var GKEY = 'pp_garage';
  function garage() { return store.get(GKEY); }
  function setGarage(g) { store.set(GKEY, g); renderGarage(); document.dispatchEvent(new CustomEvent('pp:garage')); }
  function garageLabel(g) { return g ? (g.year + ' ' + g.make + ' ' + g.model) : ''; }
  function renderGarage() {
    var g = garage();
    $$('[data-garage-label]').forEach(function (el) { el.textContent = g ? garageLabel(g) : (el.getAttribute('data-empty') || 'Add your car'); });
    $$('[data-garage-link]').forEach(function (a) { if (g && g.url) a.setAttribute('href', g.url); });
  }

  /* ---------- Parts finder ---------- */
  function initFinder(form) {
    var sy = $('[name=year]', form), sm = $('[name=make]', form), smo = $('[name=model]', form), sp = $('[name=part]', form);
    if (!sy || !sm || !smo) return;
    fill(sy, years(), 'Select year');
    sy.disabled = false;
    fill(sm, [], 'Select make'); fill(smo, [], 'Select model');
    var g = garage();
    sy.addEventListener('change', function () {
      var y = parseInt(sy.value, 10);
      fill(sm, y ? makesFor(y) : [], 'Select make'); fill(smo, [], 'Select model');
    });
    sm.addEventListener('change', function () {
      var y = parseInt(sy.value, 10);
      var ms = modelsFor(y, sm.value).map(function (v, i) { return { k: v.model, l: v.model }; });
      fill(smo, ms, 'Select model', 'k', 'l');
    });
    if (g) {
      sy.value = g.year; sy.dispatchEvent(new Event('change'));
      sm.value = g.make; sm.dispatchEvent(new Event('change'));
      smo.value = g.model;
    }
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var y = parseInt(sy.value, 10), make = sm.value, model = smo.value, part = sp ? sp.value : '';
      if (!y || !make || !model) {
        var first = !y ? sy : (!make ? sm : smo);
        first.focus();
        return;
      }
      var v = modelsFor(y, make).filter(function (x) { return x.model === model; })[0] || {};
      setGarage({ year: y, make: make, model: model, url: v.url || '' });
      var dest;
      var shortModel = model.replace(/\(.*?\)/g, '').replace(/\//g, ' ').trim();
      if (part) {
        dest = PP.routes.search + '?type=product&q=' + encodeURIComponent(make + ' ' + shortModel + ' ' + part);
      } else if (v.url) {
        dest = v.url;
      } else {
        dest = PP.routes.search + '?type=product&q=' + encodeURIComponent(make + ' ' + shortModel);
      }
      window.location.href = dest;
    });
  }

  /* ---------- Shipping math (Arizona time, UTC-7, no DST) ---------- */
  var holidays = String(PP.holidays || '').split(',').map(function (s) { return s.trim(); }).filter(Boolean);
  function azNow() { return new Date(Date.now() - 7 * 3600 * 1000); }
  function ymd(d) { return d.toISOString().slice(0, 10); }
  function isBiz(d) { var w = d.getUTCDay(); return w !== 0 && w !== 6 && holidays.indexOf(ymd(d)) === -1; }
  function addBiz(d, n) {
    var x = new Date(d.getTime());
    while (n > 0) { x.setUTCDate(x.getUTCDate() + 1); if (isBiz(x)) n--; }
    return x;
  }
  function nextBiz(d) { var x = new Date(d.getTime()); while (!isBiz(x)) x.setUTCDate(x.getUTCDate() + 1); return x; }
  var DAYS = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  var MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

  /* Returns { deadline: Date (AZ clock), shipDay: Date } for the next order window. */
  function window_() {
    var now = azNow();
    var cutoff = PP.cutoffHour || 14;
    var day = new Date(Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate(), cutoff));
    if (!isBiz(day) || now >= day) {
      day = addBiz(day, 1);
      day.setUTCHours(cutoff, 0, 0, 0);
    }
    var ship = PP.sameDay ? new Date(day.getTime()) : addBiz(day, Math.max(1, PP.handlingMax || 1));
    return { deadline: day, ship: ship, now: now };
  }
  function relDay(target, now) {
    var a = Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate());
    var b = Date.UTC(target.getUTCFullYear(), target.getUTCMonth(), target.getUTCDate());
    var diff = Math.round((b - a) / 86400000);
    if (diff === 0) return 'today';
    if (diff === 1) return 'tomorrow';
    if (diff < 7) return DAYS[target.getUTCDay()];
    return fmt(target);
  }
  function fmt(d) { return MONTHS[d.getUTCMonth()] + ' ' + d.getUTCDate(); }

  function tickCountdowns() {
    var els = $$('[data-countdown]');
    if (!els.length) return;
    var w = window_();
    var ms = w.deadline - w.now;
    var hrs = Math.floor(ms / 3600000), mins = Math.floor((ms % 3600000) / 60000);
    els.forEach(function (el) {
      var timer = $('[data-timer]', el), day = $('[data-ship-day]', el);
      if (ms > 0 && ms <= 24 * 3600000) {
        el.hidden = false;
        if (timer) timer.textContent = hrs + 'H ' + (mins < 10 ? '0' : '') + mins + 'M';
        if (day) day.textContent = relDay(w.ship, w.now);
      } else {
        el.hidden = true;
      }
    });
  }

  function renderArrivals() {
    $$('[data-arrival]').forEach(function (el) {
      var w = window_();
      var mto = el.getAttribute('data-mto') === 'true';
      var hMin = PP.handlingMin || 0, hMax = PP.handlingMax || 0;
      if (mto) { hMax = parseInt(el.getAttribute('data-mto-days') || '10', 10); }
      var shipStart = PP.sameDay || hMin === 0 ? w.deadline : addBiz(w.deadline, hMin);
      var shipEnd = hMax === 0 ? w.deadline : addBiz(w.deadline, hMax);
      var a = addBiz(shipStart, PP.transitMin || 3), b = addBiz(shipEnd, PP.transitMax || 5);
      el.textContent = fmt(a) + '–' + fmt(b);
    });
  }

  function hidePastSale() {
    if (!PP.saleEnd) return;
    if (ymd(azNow()) > PP.saleEnd) $$('[data-sale-end]').forEach(function (el) { el.hidden = true; });
  }

  /* ---------- Cart ---------- */
  function setCount(n) { $$('[data-cart-count]').forEach(function (el) { el.textContent = n; }); }
  function addToCart(id, qty) {
    return fetch(PP.routes.cartAdd, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: qty || 1 }] })
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (j) { throw new Error(j.description || 'Could not add to cart'); });
      return fetch(PP.routes.cart + '.js').then(function (c) { return c.json(); });
    }).then(function (cart) { setCount(cart.item_count); return cart; });
  }
  function announce(msg) {
    var live = $('#pp-live');
    if (!live) { live = document.createElement('div'); live.id = 'pp-live'; live.className = 'visually-hidden'; live.setAttribute('aria-live', 'polite'); document.body.appendChild(live); }
    live.textContent = msg;
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-quick-add]');
    if (!b) return;
    e.preventDefault();
    var label = b.textContent;
    b.disabled = true;
    addToCart(b.getAttribute('data-quick-add'), 1).then(function () {
      b.classList.add('is-added');
      b.textContent = b.closest('.size-btns') ? '✓' : 'Added';
      announce('Added to cart');
      setTimeout(function () { b.textContent = label; b.disabled = false; b.classList.remove('is-added'); }, 1800);
    }).catch(function (err) { b.disabled = false; announce(err.message); alert(err.message); });
  });

  /* ---------- Product form ---------- */
  function initProduct(root) {
    var dataEl = $('[data-product-json]', root);
    if (!dataEl) return;
    var product; try { product = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var form = $('form[data-product-form]', root);
    var idInput = form && $('[name=id]', form);
    var atc = $$('[data-atc]', root);
    var priceEls = $$('[data-price]', root), compareEls = $$('[data-compare]', root);
    function current() {
      var sel = $$('[data-option-index]', root).map(function (fs) {
        var c = $('input:checked', fs); return c ? c.value : null;
      });
      return product.variants.filter(function (v) {
        return v.options.every(function (o, i) { return sel[i] == null || sel[i] === o; });
      })[0];
    }
    function money(cents) {
      var n = (cents / 100).toFixed(2);
      var parts = n.split('.');
      var whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      var amount = parts[1] === '00' ? whole : whole + '.' + parts[1];
      var f = PP.moneyFormat || '${{amount}}';
      return f.replace(/\{\{\s*amount[a-z_]*\s*\}\}/, amount);
    }
    function update() {
      var v = current();
      atc.forEach(function (b) {
        b.disabled = !v || !v.available;
        var label = !v ? 'Unavailable' : (v.available ? 'Add to cart · ' + money(v.price) : 'Sold out');
        if (b.hasAttribute('data-atc-label')) b.textContent = label;
      });
      if (!v) return;
      if (idInput) idInput.value = v.id;
      priceEls.forEach(function (el) { el.textContent = money(v.price); });
      compareEls.forEach(function (el) {
        if (v.compare_at_price && v.compare_at_price > v.price) { el.hidden = false; el.textContent = money(v.compare_at_price); }
        else { el.hidden = true; }
      });
      if (v.featured_media) {
        var t = $('[data-media-id="' + v.featured_media.id + '"]', root);
        if (t) t.click();
      }
      var url = new URL(window.location.href); url.searchParams.set('variant', v.id);
      history.replaceState(null, '', url.toString());
    }
    $$('[data-option-index] input', root).forEach(function (i) { i.addEventListener('change', update); });

    /* Gallery */
    var main = $('[data-main-media]', root);
    $$('[data-media-id]', root).forEach(function (btn) {
      btn.addEventListener('click', function () {
        $$('[data-media-id]', root).forEach(function (b) { b.setAttribute('aria-current', 'false'); });
        btn.setAttribute('aria-current', 'true');
        if (main) {
          main.src = btn.getAttribute('data-src');
          main.srcset = btn.getAttribute('data-srcset') || '';
          main.alt = btn.getAttribute('data-alt') || '';
        }
      });
    });

    /* Quantity */
    $$('[data-qty]', root).forEach(function (wrap) {
      var input = $('input', wrap);
      $$('button', wrap).forEach(function (b) {
        b.addEventListener('click', function () {
          var n = Math.max(1, (parseInt(input.value, 10) || 1) + parseInt(b.getAttribute('data-step'), 10));
          input.value = n;
        });
      });
    });

    /* AJAX add */
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var q = parseInt(($('[name=quantity]', form) || {}).value, 10) || 1;
        var btn = $('[data-atc]', form);
        if (btn) btn.disabled = true;
        addToCart(idInput.value, q).then(function () {
          if (btn) { var t = btn.textContent; btn.textContent = 'Added. View cart →'; btn.disabled = false;
            btn.onclick = function (ev) { ev.preventDefault(); window.location.href = PP.routes.cart; };
            setTimeout(function () { btn.textContent = t; btn.onclick = null; }, 4000); }
          announce('Added to cart');
        }).catch(function (err) { if (btn) btn.disabled = false; alert(err.message); });
      });
    }
    $$('[data-sticky-atc-btn]').forEach(function (b) {
      b.addEventListener('click', function () { if (form) form.requestSubmit ? form.requestSubmit() : form.submit(); });
    });

    /* Sticky bar */
    var sticky = $('[data-sticky-atc]');
    var anchor = $('[data-atc]', root);
    if (sticky && anchor && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (en) {
        var e = en[0];
        sticky.classList.toggle('is-visible', !e.isIntersecting && e.boundingClientRect.top < 0);
      }).observe(anchor);
    }
  }

  /* ---------- Fitment check on product page ---------- */
  function initFit(box) {
    var make = (box.getAttribute('data-make') || '').toLowerCase();
    var model = (box.getAttribute('data-model') || '').toLowerCase();
    var ys = parseInt(box.getAttribute('data-ys'), 10), ye = parseInt(box.getAttribute('data-ye'), 10) || ys;
    var head = $('[data-fit-head]', box), sel = $('[data-fit-year]', box);
    if (sel) {
      var opts = [];
      for (var y = ye + 3; y >= ys - 3; y--) opts.push(y);
      fill(sel, opts, 'Your year');
      sel.disabled = false;
      sel.addEventListener('change', function () {
        var yy = parseInt(sel.value, 10);
        if (!yy) return;
        show(yy >= ys && yy <= ye, yy + ' ' + box.getAttribute('data-make') + ' ' + box.getAttribute('data-model'));
      });
    }
    function norm(s) { return String(s || '').toLowerCase().replace(/[^a-z0-9]/g, ''); }
    function show(ok, label) {
      box.classList.remove('fit--yes', 'fit--no');
      box.classList.add(ok ? 'fit--yes' : 'fit--no');
      if (head) head.textContent = ok ? ('Fits your ' + label + '. Check the exclusions below.') : ('Does not fit your ' + label);
    }
    function fromGarage() {
      var g = garage();
      if (!g || !ys) return;
      var sameMake = norm(g.make).indexOf(norm(make)) === 0 || norm(make).indexOf(norm(g.make)) === 0;
      var mA = norm(g.model), mB = norm(model);
      var sameModel = mA.indexOf(mB) > -1 || mB.indexOf(mA) > -1;
      if (!sameMake || !sameModel) { show(false, garageLabel(g)); return; }
      show(g.year >= ys && g.year <= ye, garageLabel(g));
      if (sel) sel.value = g.year;
    }
    fromGarage();
    document.addEventListener('pp:garage', fromGarage);
  }

  /* ---------- Vehicle selects in forms (newsletter) ---------- */
  function initVehicleSelect(sel) {
    var opts = [];
    vehicles.forEach(function (v) { opts.push(v.make + ' ' + v.model); });
    fill(sel, opts, sel.getAttribute('data-placeholder') || 'Your car');
    sel.disabled = false;
    var g = garage();
    if (g) { var label = g.make + ' ' + g.model; if (opts.indexOf(label) > -1) sel.value = label; }
    var form = sel.form, tags = form && $('[name="contact[tags]"]', form);
    if (tags) sel.addEventListener('change', function () { tags.value = 'newsletter,car:' + sel.value; });
  }

  /* ---------- Menu + facets ---------- */
  function initMenu() {
    var t = $('[data-menu-toggle]'), nav = $('[data-nav]');
    if (!t || !nav) return;
    t.addEventListener('click', function () {
      var open = nav.classList.toggle('is-open');
      t.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }
  function initFacets() {
    $$('[data-facets]').forEach(function (f) {
      f.addEventListener('change', function (e) {
        if (e.target.matches('input[type=checkbox], select')) f.submit();
      });
    });
    $$('[data-sort]').forEach(function (s) {
      s.addEventListener('change', function () {
        var u = new URL(window.location.href); u.searchParams.set('sort_by', s.value); u.searchParams.delete('page');
        window.location.href = u.toString();
      });
    });
  }

  function init() {
    renderGarage();
    $$('[data-finder]').forEach(initFinder);
    $$('[data-product]').forEach(initProduct);
    $$('[data-fit]').forEach(initFit);
    $$('[data-vehicle-select]').forEach(initVehicleSelect);
    $$('[data-garage-clear]').forEach(function (b) { b.addEventListener('click', function () { store.del(GKEY); renderGarage(); document.dispatchEvent(new CustomEvent('pp:garage')); }); });
    initMenu(); initFacets();
    tickCountdowns(); setInterval(tickCountdowns, 30000);
    renderArrivals(); hidePastSale();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
